// The pay sheet's depositor choice for a payment out of Flagged (lib/custody-screen.ts heldForPick), shared by both
// pay sheets. When Flagged holds ONE depositor's money, that depositor becomes the choice the moment it is seen, so a
// later list naming someone else reads as "gone", never as a quiet swap (Screens on cfc0d1f8, 27 Oct 2026).
// The hosts clear it through `reset` — never by setting null themselves (Screens and Astra on d9769c95: a host's own
// opening reset, in the same commit as the auto-set, left the choice null with nothing to set it again, and a later
// list then pre-selected someone else). A reset is a new opening: the one depositor is taken again.
import { useEffect, useState } from 'react';
import type { FlaggedHolder } from './custody-screen';

export function useHeldChoice(holders: ReadonlyArray<FlaggedHolder> | undefined): [string | null, (v: string | null) => void, () => void] {
  const [chosen, setChosen] = useState<string | null>(null);
  const [opening, setOpening] = useState(0);
  const only = holders?.length === 1 ? holders[0]!.partySlug : null;
  useEffect(() => { if (chosen === null && only !== null) setChosen(only); }, [chosen, only, opening]);
  return [chosen, setChosen, () => { setChosen(null); setOpening((n) => n + 1); }];
}
